module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://shadow.zhaogangimg.com/assets/zgkaihu/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 153);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.number.constructor");

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "core-js/modules/es.function.name"
var es_function_name_ = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/bank/src/main.vue?vue&type=template&id=62c4bf3a&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zg-kh-bank" },
    [
      _c(
        "el-form-item",
        {
          ref: "bankName",
          staticClass: "zg-kh-bank-item",
          attrs: {
            label: "银行名称",
            rules: _vm.defaultRules.bankName,
            prop: "bankName"
          }
        },
        [
          _c(
            "el-select",
            {
              style: { width: _vm.contentWidth },
              attrs: {
                placeholder: "请选择银行名称",
                filterable: "",
                remote: "",
                clearable: "",
                loading: _vm.bank.loading,
                "popper-append-to-body": false,
                "remote-method": _vm.debounceHanleRemoteBank
              },
              on: {
                change: _vm.handleBankChange,
                clear: _vm.handleBankClear,
                blur: _vm.handleBankBlur
              },
              model: {
                value: _vm.form.bankName,
                callback: function($$v) {
                  _vm.$set(_vm.form, "bankName", $$v)
                },
                expression: "form.bankName"
              }
            },
            _vm._l(_vm.bank.list, function(item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.bankFullName, value: item.bankFullName }
              })
            }),
            1
          )
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          ref: "branchName",
          staticClass: "zg-kh-bank-item",
          attrs: {
            label: "开户支行",
            rules: _vm.defaultRules.branchName,
            prop: "branchName"
          }
        },
        [
          _c(
            "el-select",
            {
              style: { width: _vm.contentWidth },
              attrs: {
                placeholder: "请选择开户行",
                filterable: "",
                remote: "",
                clearable: "",
                loading: _vm.branch.loading,
                "popper-append-to-body": false,
                "remote-method": _vm.handleRemoteBranch
              },
              on: {
                change: _vm.handleBranchChange,
                clear: _vm.handleBranchClear,
                blur: _vm.handleBranchBlur
              },
              model: {
                value: _vm.form.branchId,
                callback: function($$v) {
                  _vm.$set(_vm.form, "branchId", $$v)
                },
                expression: "form.branchId"
              }
            },
            _vm._l(_vm.branch.list, function(item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.bankBranchName, value: item.id }
              })
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/bank/src/main.vue?vue&type=template&id=62c4bf3a&

// EXTERNAL MODULE: external "core-js/modules/es.array.find"
var es_array_find_ = __webpack_require__(30);

// EXTERNAL MODULE: external "core-js/modules/es.number.constructor"
var es_number_constructor_ = __webpack_require__(10);

// EXTERNAL MODULE: external "core-js/modules/es.string.trim"
var es_string_trim_ = __webpack_require__(44);

// EXTERNAL MODULE: external "regenerator-runtime/runtime"
var runtime_ = __webpack_require__(7);

// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(1);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "zgkaihu/lib/utils/debounce"
var debounce_ = __webpack_require__(40);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/bank/src/main.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var CHANNEL_CODE = {
  cmb: 50002,
  piaoju: 50004,
  huifu: 50007,
  tenpay: 50008
};
/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  name: 'ZgKhBank',
  props: {
    labelWidth: {
      type: String,
      default: '100px'
    },
    contentWidth: {
      type: String,
      default: '360px'
    },
    channelCode: {
      type: Number,
      default: CHANNEL_CODE.tenpay
    },
    required: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      form: {
        bankName: '',
        //name和code不能做为唯一标识，自定义一个index作为唯一标识
        branchId: '',
        branchName: ''
      },
      bank: {
        list: [],
        selected: null,
        keywords: '',
        loading: false,
        page: {
          pageNo: 1,
          pageSize: 20
        }
      },
      branch: {
        list: [],
        selected: null,
        keywords: '',
        loading: false,
        page: {
          pageNo: 1,
          pageSize: 20
        }
      },
      defaultRules: {
        bankName: {
          required: this.required,
          message: '请选择银行名称',
          validator: function validator(rule, value, callback) {
            if (!_this.required) {
              callback();
            } else {
              if (!_this.form.bankName) {
                callback(new Error('请选择银行名称'));
              } else {
                callback();
              }
            }
          },
          trigger: 'change'
        },
        branchName: {
          required: this.required,
          validator: function validator(rule, value, callback) {
            if (!_this.required) {
              callback();
            } else {
              if (!_this.form.branchName) {
                callback(new Error('请选择开户支行'));
              } else {
                callback();
              }
            }
          },
          trigger: 'change'
        }
      },
      debounceHanleRemoteBank: null,
      debounceHanleRemoteBranch: null
    };
  },
  created: function created() {
    this.handleBankSearch();
    this.debounceHanleRemoteBank = debounce_default()(300, this.handleRemoteBank);
    this.debounceHanleRemoteBranch = debounce_default()(300, this.handleRemoteBranch);
  },
  methods: {
    handleRemoteBank: function handleRemoteBank(keywords) {
      if (keywords) {
        keywords = keywords.trim();
      }

      this.bank.keywords = keywords;
      this.handleBankSearch();
    },
    handleBankSearch: function handleBankSearch() {
      var _arguments = arguments,
          _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isInit, resp, _this2$$zgKaihu$$conv, success, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isInit = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                _context.prev = 1;
                _this2.bank.loading = true;
                _context.next = 5;
                return _this2.$zgKaihu.$get('paycore.getChannelBankInfos', {
                  param: {
                    channelCode: _this2.channelCode,
                    pageIndex: _this2.bank.page.pageNo,
                    pageSize: _this2.bank.page.pageSize,
                    bankName: _this2.bank.keywords
                  }
                }, {
                  notNeedLoading: true
                });

              case 5:
                resp = _context.sent;
                _this2$$zgKaihu$$conv = _this2.$zgKaihu.$convertResp(resp), success = _this2$$zgKaihu$$conv.success, data = _this2$$zgKaihu$$conv.data;

                if (success && data.payChannelBankInfoResultList && data.payChannelBankInfoResultList.length > 0) {
                  _this2.bank.list = data.payChannelBankInfoResultList;

                  if (isInit) {
                    _this2.handleBankChange(_this2.bank.keywords, isInit);
                  }
                } else {
                  _this2.bank.list = [];
                }

                if (isInit) {
                  _this2.bank.keywords = '';
                }

                _this2.bank.loading = false;
                _context.next = 17;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);
                console.log(_context.t0);
                _this2.bank.loading = false;

                if (isInit) {
                  _this2.bank.keywords = '';
                }

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 12]]);
      }))();
    },
    handleBankChange: function handleBankChange(name) {
      var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var bank = this.bank.list.find(function (ele) {
        return ele.bankFullName === name;
      });

      if (bank) {
        this.bank.selected = bank;

        if (isInit) {
          this.form.bankName = name;
        } else {
          //清空支行信息
          this.form.branchId = '';
          this.form.branchName = '';
          this.branch.selected = null;
          this.$emit('change', {
            key: 'branch',
            value: '',
            branch: undefined
          });
          this.handleBranchSearch();
        }
      }

      this.value.bank = bank;
      this.$emit('change', {
        key: 'bank',
        value: name,
        bank: bank
      });
    },
    handleBankClear: function handleBankClear() {
      this.form.bankName = '';
      this.form.branchId = '';
      this.form.branchName = '';
      this.bank.keywords = '';
      this.bank.list = [];
      this.bank.selected = null;
      this.branch.keywords = '';
      this.branch.list = [];
      this.branch.selected = null;
      this.value.branch = null;
      this.value.bank = null;
      this.$emit('change', {
        key: 'branch',
        value: '',
        branch: undefined
      });
      this.handleBankSearch();
    },
    handleBankBlur: function handleBankBlur() {
      this.bank.keywords = '';
    },
    //支行事件处理
    handleRemoteBranch: function handleRemoteBranch(keywords) {
      if (keywords) {
        keywords = keywords.trim();
      }

      this.branch.keywords = keywords;
      this.handleBranchSearch();
    },
    handleBranchSearch: function handleBranchSearch() {
      var _arguments2 = arguments,
          _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var isInit, params, resp, _this3$$zgKaihu$$conv, success, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isInit = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : false;

                if (!(!_this3.branch.keywords && !_this3.bank.selected)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                params = {
                  pageIndex: _this3.branch.page.pageNo,
                  pageSize: _this3.branch.page.pageSize,
                  channelCode: _this3.channelCode
                };

                if (_this3.branch.keywords) {
                  params.condition = _this3.branch.keywords;
                  params.bankId = 0;
                }

                if (_this3.bank.selected) {
                  params.bankId = _this3.bank.selected.id;
                }

                _context2.prev = 6;
                _this3.branch.loading = true;
                _context2.next = 10;
                return _this3.$zgKaihu.$get('paycore.getBranchBankInfo', params, {
                  notNeedLoading: true
                });

              case 10:
                resp = _context2.sent;
                _this3$$zgKaihu$$conv = _this3.$zgKaihu.$convertResp(resp), success = _this3$$zgKaihu$$conv.success, data = _this3$$zgKaihu$$conv.data;

                if (success && data && data.payChannelBranchBankInfoResultList.length > 0) {
                  _this3.branch.list = data.payChannelBranchBankInfoResultList;

                  if (isInit) {
                    _this3.handleBranchChange(_this3.branch.keywords, isInit);
                  }
                } else {
                  _this3.branch.list = [];
                }

                if (isInit) {
                  _this3.branch.keywords = '';
                }

                _this3.branch.loading = false;
                _context2.next = 22;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](6);
                console.log(_context2.t0);
                _this3.branch.loading = false;

                if (isInit) {
                  _this3.branch.keywords = '';
                }

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[6, 17]]);
      }))();
    },
    handleBranchChange: function handleBranchChange(val, isInit) {
      var branch;

      if (isInit) {
        branch = this.branch.list.find(function (ele) {
          return ele.bankBranchName === val;
        });
      } else {
        branch = this.branch.list.find(function (ele) {
          return ele.id === val;
        });
      }

      if (branch) {
        this.branch.selected = branch;
        this.form.branchName = branch.bankBranchName;
        this.form.branchId = branch.id; //反写主行信息

        var bank;

        if (this.bank.list && this.bank.list.length > 0) {
          bank = this.bank.list.find(function (ele) {
            return ele.id === branch.bankId;
          });
        }

        if (!bank) {
          bank = {
            id: branch.bankId,
            bankCode: branch.bankCode,
            bankFullName: branch.bankName
          };
          this.bank.list.push(bank);
        }

        this.bank.selected = bank;
        this.form.bankName = bank.bankFullName;
        this.value.bank = bank;
      }

      this.value.branch = branch;
      this.$emit('change', {
        key: 'branch',
        value: this.form.branchName,
        branch: branch
      });
    },
    handleBranchClear: function handleBranchClear() {
      this.form.branchId = '';
      this.form.branchName = '';
      this.branch.keywords = '';
      this.branch.selected = null;
      this.value.branch = null;
      this.handleBranchSearch();
    },
    handleBranchBlur: function handleBranchBlur() {
      this.branch.keywords = '';
    },
    validate: function validate() {
      var _this4 = this;

      var success = true;
      this.$refs.bankName.validate('', function (message, field) {
        if (message) {
          _this4.$message.error(message);

          success = false;
        }
      });

      if (!success) {
        return success;
      }

      this.$refs.branchName.validate('', function (message, field) {
        if (message) {
          _this4.$message.error(message);

          success = false;
        }
      });
      return success;
    },
    clearBank: function clearBank() {
      this.handleBankClear();
    },
    setValue: function setValue(value) {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!value.bankName) {
                  _context3.next = 4;
                  break;
                }

                _this5.bank.keywords = value.bankName;
                _context3.next = 4;
                return _this5.handleBankSearch(true);

              case 4:
                if (value.branchName) {
                  _this5.branch.keywords = value.branchName;

                  _this5.handleBranchSearch(true);
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./packages/bank/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/bank/src/main.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/bank/src/main.vue"
/* harmony default export */ var main = (component.exports);
// CONCATENATED MODULE: ./packages/bank/index.js


/* istanbul ignore next */

main.install = function (Vue) {
  Vue.component(main.name, main);
};

/* harmony default export */ var bank = __webpack_exports__["default"] = (main);

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.function.name");

/***/ }),

/***/ 30:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.find");

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/utils/debounce");

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.trim");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("regenerator-runtime/runtime");

/***/ })

/******/ });